import { callDecimal } from "../utils.ts";
import { ManageAssetWithLicense } from "../common-types/manageAssets.ts";

export interface TermLoc {
  len: number;
  pos: number;
}

export interface TermCfi {
  base: string;
  begin: string;
  end: string;
}

export interface Location {
  cfi: string;
  chapter_title: string;
  id: number;
  term_cfis?: TermCfi[];
  term_locs: TermLoc[];
  text: string;
  page?: string;
}

export interface SearchContentResponse {
  asset: ManageAssetWithLicense;
  count: number;
  locations?: Location[];
  type: string;
  vbid: string;
}

export async function searchBookContent(query: string, vbid: string) {
  const queryParams = new URLSearchParams();
  queryParams.set("q", query);
  const response = await callDecimal<SearchContentResponse>(
    `/api/v1/search/${vbid}?${queryParams.toString()}`
  );
  return response;
}
